// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponBetsList_root__FZXyS","clearCoupon":"CouponBetsList_clearCoupon__f_FEy"};